import React, { useEffect } from 'react'
import VersionCheckService from '../services/version/VersionCheckService'

const useVersionCheck = (setIsUpdateAvailable) => {
	useEffect(() => {
		const versionCheckService = new VersionCheckService(60000)

		const onUpdate = (latestVersion) => {
			console.log(`New version available: ${latestVersion}`)
			setIsUpdateAvailable(true)
		}

		versionCheckService.setOnUpdate(onUpdate)
		versionCheckService.start().finally()

		return () => {
			versionCheckService.stop()
		}
	}, [setIsUpdateAvailable])
}

export default useVersionCheck
